import { combineReducers } from "redux";

import firebaseReducer from "./firebase";
import firestoreReducer from "./firestore";
import discoverReducer from "./discover";
import cart from "./cart";
import menu from "./menu";
import popularMeals from "./popularMeals";
import popularRestaurants from "./popularRestaurants";

export default combineReducers({
  firebase: firebaseReducer,
  DB: firestoreReducer,
  discover: discoverReducer,
  cart,
  menu,
  popularMeals,
  popularRestaurants,
});
